import React, { useRef } from 'react';
import { debugWallet, UDS_OPEN_BOA_CREDIT_APP_COMPLETED } from 'wallet-manager';
import { eventBus } from '@atc/cai-event-bus';
import { jsx } from 'react/jsx-runtime';
const BOA_CREDIT_APP_URL = 'https://secure.bankofamerica.com/apply-now-services/auto-loans/initialize-dealer-track/v1/init?requesttype=VLDT&product=auto&source=1&channel=11';

// Helper to create form field objects
const createField = function (section, key, value) {
  let fallback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
  return {
    name: `${section}.${key}`,
    value: value || fallback
  };
};

/**
 * Hidden form component for BoA credit application submission
 * Uses native HTML form for external POST submission to BoA
 */
const BOACreditAppForm = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
    formData = null,
    onSubmit = null
  } = props;
  const formRef = useRef(null);

  // Helper method to emit error event with payload
  const emitErrorEvent = function (error) {
    let context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'unknown';
    const errorPayload = {
      success: false,
      error: error instanceof Error ? error.message : String(error),
      context,
      timestamp: new Date().toISOString()
    };
    debugWallet('UDS', 'BoA', `Error in ${context}:`, error);
    eventBus.emit(UDS_OPEN_BOA_CREDIT_APP_COMPLETED, errorPayload);
  };
  const handleSubmit = () => {
    try {
      if (formRef.current) {
        formRef.current.submit();
        setTimeout(() => {
          debugWallet('UDS', 'BoA', 'Form submitted - if no tab opened, check popup blocker settings');
        }, 100);
        if (onSubmit) {
          onSubmit();
        }
      } else {
        const error = 'Form ref is null, cannot submit';
        emitErrorEvent(error, 'form_ref_null');
      }
    } catch (error) {
      emitErrorEvent(error, 'form_submission');
    }
  };

  // Make the submit function available to parent components
  React.useImperativeHandle(ref, () => ({
    submit: handleSubmit
  }));
  if (!formData) {
    debugWallet('UDS', 'BoA', 'No formData provided');
    return null;
  }
  const boaCreditAppUrl = BOA_CREDIT_APP_URL;

  // Destructure formData for cleaner field definitions
  const {
    dealerInfo,
    vehicleInfo,
    paymentInfo
  } = formData || {};

  // Create form fields using helper function for better readability
  const dealerFields = [createField('dealerInfo', 'dealerId', dealerInfo?.dealerId), createField('dealerInfo', 'name', dealerInfo?.name), createField('dealerInfo', 'addressLine1', dealerInfo?.addressLine1), createField('dealerInfo', 'city', dealerInfo?.city), createField('dealerInfo', 'state', dealerInfo?.state), createField('dealerInfo', 'zipCode', dealerInfo?.zipCode), createField('dealerInfo', 'phoneNumber', dealerInfo?.phoneNumber)];
  const vehicleFields = [createField('vehicleInfo', 'vehicleCondition', vehicleInfo?.vehicleCondition), createField('vehicleInfo', 'year', vehicleInfo?.year), createField('vehicleInfo', 'make', vehicleInfo?.make), createField('vehicleInfo', 'model', vehicleInfo?.model), createField('vehicleInfo', 'trim', vehicleInfo?.trim), createField('vehicleInfo', 'interiorColor', vehicleInfo?.interiorColor), createField('vehicleInfo', 'exteriorColor', vehicleInfo?.exteriorColor), createField('vehicleInfo', 'chromeStyleID', vehicleInfo?.chromeStyleId), createField('vehicleInfo', 'vin', vehicleInfo?.vin), createField('vehicleInfo', 'stockNumber', vehicleInfo?.stockNumber), createField('vehicleInfo', 'certifiedUsed', vehicleInfo?.certifiedUsed, 'N'), createField('vehicleInfo', 'mileage', vehicleInfo?.mileage), createField('vehicleInfo', 'photoUrl', vehicleInfo?.photoUrl)];
  const paymentFields = [createField('paymentInfo', 'price', paymentInfo?.price), createField('paymentInfo', 'msrp', paymentInfo?.msrp), createField('paymentInfo', 'downPayment', paymentInfo?.downPayment, '0'), createField('paymentInfo', 'rebate', paymentInfo?.rebate, '0'), createField('paymentInfo', 'term', paymentInfo?.term), createField('paymentInfo', 'netTrade', paymentInfo?.netTrade, '0'), createField('paymentInfo', 'dueAtSign', paymentInfo?.dueAtSign || paymentInfo?.downPayment, '0'), createField('paymentInfo', 'selfReportedCredit', paymentInfo?.selfReportedCredit), createField('paymentInfo', 'creditTier', paymentInfo?.creditTier), createField('paymentInfo', 'estimatedPayment', paymentInfo?.estimatedPayment), createField('paymentInfo', 'apr', paymentInfo?.apr), createField('paymentInfo', 'loanAmount', paymentInfo?.loanAmount)];
  const allFields = [...dealerFields, ...vehicleFields, ...paymentFields];
  return /*#__PURE__*/jsx("div", {
    className: "boa-credit-app-form-container",
    children: /*#__PURE__*/jsx("form", {
      ref: formRef,
      action: boaCreditAppUrl,
      method: "POST",
      target: "_blank",
      style: {
        display: 'none'
      },
      children: allFields.map(field => /*#__PURE__*/jsx("input", {
        type: "hidden",
        name: field.name,
        value: field.value
      }, field.name))
    })
  });
});
export { BOACreditAppForm as default };
